/**
 *
 * @author: Adalto Junior
 * DATE: 27/08/2014
 *
 */


Monet.UI = Monet.UI || {};
Monet.UI.Pagination = function () {

    this.entity = null;
    this.listElement = null;
    this.lastHeightScroll = 0;
    this.lastScrollTop = 0;
    this.scroll = null;

    this.loading = new Monet.UI.LoadingData();

    this.setEntity = function (entity) {
        this.entity = entity;
    };

    this.setListElement = function (listElement) {
        this.listElement = listElement;
    };

    this.scrollEventListenerFunction = function (scope) {

        return function () {
          const { scrollHeight, scrollTop, offsetHeight, scrollLeft } = scope.listElement;

          const scrollIsVertical = scrollTop > scope.lastScrollTop;
          const scrollIsOnBottom = (scrollTop + offsetHeight) >= scrollHeight;

          if (scrollHeight >= scope.lastHeightScroll && scrollIsVertical && scrollIsOnBottom && scope.executePagination) {
              scope.newPage = scrollTop;
              scope.executePagination(scope.entity);
          }

          scope.lastLeftScroll = scrollLeft;
          scope.lastHeightScroll = scrollHeight;
          scope.lastScrollTop = scrollTop;
        };
    }(this);
};
